import React, { useEffect } from 'react';
import defaultClasses from './childrenPopup.css';
import { useScrollLock } from "@magento/peregrine";
import { setDocumentScrollAvailable } from "@magento/peregrine/lib/hooks/useScrollLock";
var ChildrenPopup = props => {
  var {
    visiblePopup,
    children
  } = props;
  useScrollLock(!!visiblePopup);

  //in order to remove changes if navigating our of popup
  useEffect(() => {
    return () => {
      setDocumentScrollAvailable(null);
    };
  }, []);
  return visiblePopup && children ? /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.root
  }, /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.container
  }, children)) : null;
};
export default ChildrenPopup;